
import { useState, useRef } from 'react';
import { DateRangePicker } from 'rsuite';
import { FaCalendar, FaClock } from 'react-icons/fa';
import 'rsuite/dist/rsuite.min.css'; // Import RSuite CSS

const DatePicker = () => {
    const [showDatePicker, setShowDatePicker] = useState(false);

    const [dateRange, setDateRange] = useState([new Date(), new Date()]); // Initial date range
    const [resetDate,setResetDate] = useState(true);
    const datePickerContainerRef = useRef(null);

    const reset = () => {
        setDateRange([new Date(), new Date()]);
        setResetDate(true);
      }

    const formatDate = (date) => {
    return date ? date.toISOString().slice(2, 10) : '';
    };

    return (
        <div>
            <style>
                {`
                /* Hide the default DateRangePicker input */
                 .rs-picker-input-group {
                    visibility: hidden !important;
                }
                `}
            </style>

            <div className="picker-container w-full "> {/* Parent container */}

                {/* Custom Input for Date Picker */}
                <div className='relative'>
                    <div ref={datePickerContainerRef} className="relative w-[280px]"> {/* Adding margin-top */}
                        <span>
                            <div className='w-[280px] h-[40px] bg-[white] text-[#b2b2b2] items-center border border-[#dcdfe6] rounded flex group z-0'>
                                <div onClick={() => setShowDatePicker(true)} className='w-[250px] h-full flex itmes-center'>
                                    <div className='flex flex-col justify-center'>
                                        <svg
                                        className="w-4 h-4 ml-3"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="CalendarMonthIcon"
                                        title="CalendarMonth"
                                        fill='#b2b2b2'
                                        >
                                        <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"></path>
                                        </svg>
                                    </div>
                                    <input
                                        placeholder="Start Date"
                                        className="w-[100px] h-full outline-none text-center text-[black]"
                                        value={
                                            !resetDate ? formatDate(dateRange[0]) : 'Start Date'
                                        }
                                    />
                                    <div className='flex flex-col justify-center'>
                                        <span>~</span>
                                    </div>
                                    <input
                                        placeholder="End Date"
                                        className="w-[100px] h-full outline-none text-center text-[black]"
                                        value={
                                            !resetDate ? formatDate(dateRange[1]) : 'End Date'
                                        }
                                    />
                                </div>
                                {dateRange.length > 1 && (
                                    <div onClick={reset} className='h-[40px] w-[40px] outline-none bg-[transparent] flex flex-col justify-center z-100 cursor-pointer'>
                                        <svg
                                            className="w-4 h-4 ml-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                            focusable="false"
                                            viewBox="0 0 24 24"
                                            data-testid="HighlightOffIcon"
                                            title="HighlightOff"
                                            fill='#b2b2b2'
                                        >
                                            <path d="M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"></path>
                                        </svg>
                                    </div>
                                )}

                            </div>
                        </span>
                        {showDatePicker && (
                            <div className="absolute top-[10px] left-[-200px]"> {/* Adjusting the date picker position */}
                                <DateRangePicker
                                    format="yyyy-MMM-dd"
                                    defaultValue={[new Date('2022-12-18'), new Date('2025-10-2')]}
                                    value={dateRange}
                                    showMeridiem
                                    caretAs={FaCalendar}
                                    open={true} // Keep it open when visible
                                    onChange={(newRange) => {
                                        setDateRange(newRange);
                                        setResetDate(false);
                                    }}
                                    onClose={() => setShowDatePicker(false)} // Close on focus loss
                                    container={datePickerContainerRef.current} // Attach picker to container
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DatePicker;